export default __webpack_public_path__ + "static/media/sales.c82a20be.svg";